import { useLocation, Navigate, useNavigate } from "react-router-dom";
import { loginRoute, selectPlanRoute } from "../routes/reactRoutes";
import verifyToken from "./CheckToken";
import Layout from "../components/layout/Layout";
import { Box } from "@mui/material";
import drawerDim from "../theme/drawerDimensions";
import { useSelector, useDispatch } from "react-redux";
import {
  approveRejectModerationRoute,
  meRoute,
  updateDeviceIdRoute,
  getAllClientsRoute,
  getAllProjectsRoute,
} from "../routes/apiRoutes";
import { toast } from "react-toastify";
import { freePlan, login } from "../Redux/authenticationSlice";
import { useEffect, useState } from "react";
import Loading from "../components/commonControls/loading";
import useTheme from "@mui/material/styles/useTheme";
import { apply } from "../Redux/themeSlice";
import { getToken } from "firebase/messaging";
import { messaging } from "../firebase";
import { send } from "../Redux/deviceSlice";
import { EllipsisTooltips } from "../components/commonControls/EllipsisTooltips";
import Tooltip from "../components/commonControls/TooltipCustom";
import { update } from "../Redux/moderationSlice";
import axiosInstance from "../axios/axiosInstance";
import apiService from "../services/apiService";
import "./langAnimation.css";
import { setClientProject } from "../Redux/clientProjectSlice";

export const PrivateRoute = ({ children }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const drawerMargins = {
    marginLeft: { sm: 0, md: `${drawerDim.width}px` },
    background: theme.palette.componentBackgrounds.page,
    marginTop: `${drawerDim.height}px`,
    marginBottom: `${drawerDim.bottom}px`,
    minHeight: `calc(100vh - ${drawerDim.height}px - ${drawerDim.bottom}px)`,
  };
  const location = useLocation();
  const noLayoutRoutes = ["/subscription-plans", "/my-plan"];
  const freePlanValue = useSelector(
    (state) => state.authenticationValues.freePlan
  );
  const isChangingDirection = useSelector(
    (state) => state.themeValues.isChangingDirection
  );
  const isNoLayoutRoute = noLayoutRoutes.includes(location.pathname);
  const dispatch = useDispatch();
  const deviceId = useSelector((state) => state.deviceValues.deviceId);

  const currentUser = useSelector(
    (state) => state.authenticationValues.currentUser
  );
  const selectedClient = useSelector(
    (state) => state.clientProjectValues.selectedClient
  );
  const selectedProject = useSelector(
    (state) => state.clientProjectValues.selectedProject
  );
  const subscriptionStatus = useSelector(
    (state) => state.authenticationValues.subscriptionStatus
  );
  const notificationValues = useSelector(
    (state) => state.notificationValues.unreadCount
  );
  const moderationModified = useSelector(
    (state) => state.moderationCountValues.lastModeration
  );
  const roles =
    currentUser.userRoles?.map((roleItem) => roleItem?.role?.name) || [];
  const colors = useSelector((state) => state.themeValues.colors);
  const [userVerified, setUserVerified] = useState(false);
  const [tooltipElement, setTooltipElement] = useState(null);
  const handleShowTooltip = (element) => {
    setTooltipElement(element);
  };
  const [isLoading, setIsLoading] = useState(true);

  

  useEffect(() => {
    if (children?.props?.children?.props?.title) {
      document.title = children?.props.children.props.title;
    }
  }, [children]);

  useEffect(() => {
    if ((currentUser.firstName || userVerified) && !deviceId) {
      requestPermission();
    }
    if (currentUser.firstName && !subscriptionStatus && !freePlanValue) {
      navigate(selectPlanRoute);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userVerified, currentUser]);

  useEffect(() => {
    if (roles.includes("Moderator")) {
      getCount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificationValues, moderationModified, currentUser]);

  async function getCount() {
    try {
      const countData = await axiosInstance.get(approveRejectModerationRoute, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (countData.status === 200) {
        dispatch(update(countData.data?.response));
      }
    } catch {}
  }

  useEffect(() => {
    const handleToken = async () => {
      try {
        const { data } = await axiosInstance.get(meRoute, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        if (data.statusCode === 200 || data.statusCode === 201) {
          dispatch(
            login({
              user: data.response,
              token: null,
              avatar: localStorage.getItem("avatar"),
              subscriptionStatus: data.response.subscriptionStatus,
            })
          );
          localStorage.setItem(
            "prevLocation",
            `${location.pathname}${location.search}`
          );
          if (data.response.freePlan) {
            dispatch(
              freePlan({
                free: true,
                remainingDays: data.response.remainingDays,
              })
            );
          }

          if (data.response?.theme) {
            dispatch(
              apply({
                colors: colors,
                mainColor: data.user.theme.mainColor,
                mode: data.response.theme.mode,
              })
            );
          }
          setUserVerified(true);
        } else {
          toast.dismiss();
          toast.error(`Unexpected response`, { autoClose: false });
        }
      } catch (error) {}
      setIsLoading(false);
    };
    const getClientsAndProjects = async () => {
       // NEW: load clients and projects once after user is known
       try {
        const [clientsRes, projectsRes] = await Promise.all([
          apiService.get(`${getAllClientsRoute}?take=5&&pageNo=1&&searchText=`),
          apiService.get(`${getAllProjectsRoute}?take=5&&pageNo=1&&searchText=`),
        ]);
        dispatch(
          setClientProject({
            clients: clientsRes?.clients || clientsRes || [],
            projects: projectsRes?.projects || projectsRes || [],
          })
        );
      } catch {}
    }

    if (!currentUser.firstName) handleToken();
    if(!selectedClient && !selectedProject) getClientsAndProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!currentUser.firstName && verifyToken() && isLoading) {
    return <Loading />;
  }

  //Notification permission/////////////////////
  async function requestPermission() {
    try {
      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        const token = await getToken(messaging, {
          vapidKey:
            "BBksbyUaGk4sKMSHOSckAocQwpu5I03DtnnPKgz5XKX-1uDc7BN0tCzfx9LVWPSQIGGhEfXmSLsfYyTloS7qU5A",
        });
        dispatch(send({ deviceId: token }));
        sendDeviceId(token);
      } else if (permission === "denied") {
        toast.dismiss();
        toast.info(
          "Push Notifications are disabled in this browser. Check by clicking info button on address bar.",
          { autoClose: false }
        );
      }
    } catch {}
  }
  async function sendDeviceId(deviceId) {
    try {
      await axiosInstance.patch(
        `${updateDeviceIdRoute}${currentUser.id}`,
        {
          deviceId: deviceId,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
    } catch {}
  }

  return currentUser.firstName || userVerified ? (
    isNoLayoutRoute ? (
        <Box
          sx={{
            minWidth: "100%",
            minHeight: "100vh",
          }}
        >
          {children}
        </Box>
    ) : (
      <>
        <Layout />
        <EllipsisTooltips onShowTooltip={handleShowTooltip} />
        <Tooltip element={tooltipElement} />

        <Box
          sx={{
            ...drawerMargins,
            animation: isChangingDirection
              ? "vanishOut 0.5s ease-in-out forwards"
              : "vanishIn 0.5s ease-in-out forwards",
            willChange: "filter",
          }}
        >
          {children}
        </Box>
      </>
    )
  ) : (
    <Navigate to={loginRoute} state={{ from: location }} replace />
  );
};
